import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class AppMatPaginatorIntl extends MatPaginatorIntl {

    override itemsPerPageLabel = $localize`:paginator label|Items per page@@paginatorItemsPerPage:Items per page:`;
    override nextPageLabel  = $localize`:paginator label|Next page@@paginatorNext:Next page`;
    override previousPageLabel = $localize`:paginator label|Previous page@@paginatorPrevious:Previous page`;
    override firstPageLabel = $localize`:paginator label|First page@@paginatorFirst:First page`;
    override lastPageLabel  = $localize`:paginator label|Last page@@paginatorLast:Last page`;

    // You can also translate the range text here
    override getRangeLabel = (page: number, pageSize: number, length: number): string => {
        if (length === 0 || pageSize === 0) {
            return $localize`:paginator range|No items@@paginatorRangeEmpty:0 of ${length}`;
        }

        const startIndex = page * pageSize;
        const endIndex = Math.min(startIndex + pageSize, length);

        // Example: "1 – 10 of 123" – translate the structure as you like
        return $localize`:paginator range|Range@@paginatorRange:${startIndex + 1} – ${endIndex} of ${length}`;
    };
}